import React from "react";
import { DownArrowIcon, GreenEllipse, RedEllipse } from "../../Icons";

const CardDropdown = ({ activeCard }) => {
  return (
    <>
      {activeCard && (
        <div className="relative flex w-full justify-start items-center py-2 px-3 card-dropdown-wrapper rounded-xl cursor-pointer">
          <div className="flex">
            {activeCard.status === "Active" ? (
              <img
                src={
                  activeCard.card_brand === "Visa"
                    ? "assets/logos/visa-othercard-bg.png"
                    : "assets/logos/match-move-othercard-bg.png"
                }
                alt="Other Cards"
                className="rounded-md"
              />
            ) : (
              <img
                src={`${
                  activeCard.card_provider === "MM"
                    ? "assets/logos/match-move-othercard-bg.png"
                    : "assets/logos/visa-othercard-bg.png"
                }`}
                alt="Other Cards"
                className={`rounded-md ${
                  activeCard.status !== "Active" ? "bg-zinc-400 opacity-60" : ""
                }`}
              />
            )}
            <div className="px-3">
              <p className="card-dropdown-cardholdername text-sm font-medium leading-5 tracking-[0.07px] ">
                {activeCard.name}
              </p>
              <span className="flex pt-2 items-center space-x-1">
                {activeCard.status === "Active" ? (
                  <GreenEllipse />
                ) : (
                  <RedEllipse />
                )}
                <p className="card-dropdown-status font-normal text-sm leading-5 tracking-[0.07px] whitespace-nowrap">
                  {activeCard.status} | · · {activeCard.card_number.slice(-4)}
                </p>
              </span>
            </div>
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center pr-[18px] hover:cursor-pointer">
            <DownArrowIcon className="h-5 w-5" />
          </div>
        </div>
      )}
    </>
  );
};

export default CardDropdown;
